/* eslint-disable react/jsx-key */
import React, { useMemo } from "react";
import { Column } from "react-table";

import { User, UserRole } from "types/user";
import DataTable from "components/DataTable";
import UserRow from "./UserRow";
import { SelectFilter } from "components";
import { useUser } from "context/user";
import { Callback } from "types";

interface Props {
  users: User[];
  highlightUserId: string;
  saveUser: Callback;
  deleteUser: Callback;
}

const UsersDataTable: React.FC<Props> = ({
  users,
  saveUser,
  deleteUser
}: Props) => {
  const { user: actor } = useUser()!;
  const data: User[] = useMemo(() => users, [users]);
  const columns: Column<User>[] = useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => (
          <UserRow
            user={original}
            saveUser={saveUser}
            deleteUser={deleteUser}
          />
        )
      },
      {
        Header: "Username",
        accessor: "username"
      },
      {
        Header: "First Name",
        accessor: "first_name"
      },
      {
        Header: "Last Name",
        accessor: "last_name"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "Coach First Name",
        id: "coach_first_name",
        accessor: row => row.coach?.first_name,
        disableFilters: actor.privs <= UserRole.Coach
      },
      {
        Header: "Coach Last Name",
        id: "coach_last_name",
        accessor: row => row.coach?.last_name,
        disableFilters: actor.privs <= UserRole.Coach
      },
      {
        Header: "Coach",
        id: "coach_name",
        accessor: row => `${row.coach?.first_name} ${row.coach?.last_name}`,
        disableSortBy: true,
        Filter: SelectFilter,
        filter: "equals",
        disableFilters: actor.privs <= UserRole.Coach
      },
      {
        Header: "Organization",
        id: "organization_display_name",
        accessor: row => row.organization?.displayName,
        disableSortBy: actor.privs <= UserRole.OrgAdmin,
        Filter: SelectFilter,
        filter: "equals",
        disableFilters: actor.privs <= UserRole.OrgAdmin
      }
    ],
    []
  );

  return <DataTable columns={columns} data={data} tableTitle="Clients" />;
};

export default UsersDataTable;
